export const normalizeCycle = (v) => {
  const c = String(v || '').toLowerCase();
  if (c === 'daily' || c === 'weekly' || c === 'monthly') return c;
  return 'monthly';
};

export const cycleTitle = (v) => {
  const map = { daily: 'Daily', weekly: 'Weekly', monthly: 'Monthly' };
  return map[normalizeCycle(v)];
};

export const cycleUnit = (v) => {
  const map = { daily: 'day', weekly: 'week', monthly: 'month' };
  return map[normalizeCycle(v)];
};

export const cycleUnits = (v) => `${cycleUnit(v)}s`;

export const durationLabel = (v) => {
  const map = {
    daily: 'Number of days',
    weekly: 'Number of weeks',
    monthly: 'Number of months'
  };
  return map[normalizeCycle(v)];
};

export const rateLabel = (v) => {
  const map = {
    daily: 'Daily rate',
    weekly: 'Weekly rate',
    monthly: 'Monthly rate'
  };
  return map[normalizeCycle(v)];
};

export const extraPeriodPrompt = (v) => {
  const map = {
    daily: 'Extra days?',
    weekly: 'Extra weeks?',
    monthly: 'Extra months?'
  };
  return map[normalizeCycle(v)];
};

export const billingSummary = (v, count) => `${cycleTitle(v)} × ${count || 1}`;

export const invoiceRhythm = (v) => {
  const map = {
    daily: 'one invoice per day',
    weekly: 'one invoice per week',
    monthly: 'one invoice per month'
  };
  return map[normalizeCycle(v)];
};

export const addCycle = (dateStr, cycle, n = 1) => {
  const d = new Date(`${dateStr}T00:00:00`);
  const c = normalizeCycle(cycle);
  if (c === 'daily') d.setDate(d.getDate() + n);
  else if (c === 'weekly') d.setDate(d.getDate() + (n * 7));
  else d.setMonth(d.getMonth() + n);
  return d.toISOString().slice(0, 10);
};

export const periodEnd = (start, cycle) => {
  const next = addCycle(start, cycle, 1);
  const d = new Date(`${next}T00:00:00`);
  d.setDate(d.getDate() - 1);
  return d.toISOString().slice(0, 10);
};

export const addDays = (dateStr, n = 1) => {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const extraUntilDate = (currentEnd, extraCycle, extraCount) => {
  const extraStart = addDays(currentEnd, 1);
  return periodEnd(addCycle(extraStart, extraCycle, Math.max(1, extraCount) - 1), extraCycle);
};

export const daysInclusive = (start, end) => {
  if (!start || !end) return 1;
  const a = new Date(`${start}T00:00:00`);
  const b = new Date(`${end}T00:00:00`);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return 1;
  return Math.max(1, Math.round((b - a) / 86400000) + 1);
};

export const suggestedReturnRent = (rental, days) => {
  const cycle = normalizeCycle(rental?.billing_cycle);
  const n = Math.max(1, parseInt(days, 10) || 1);
  const total = (rental?.items || []).reduce((sum, it) => {
    const rate = parseFloat(it.period_rate != null ? it.period_rate : it.daily_rate) || 0;
    const qty = parseInt(it.quantity, 10) || 1;
    let daily = rate;
    if (cycle === 'weekly') daily = rate / 7;
    else if (cycle === 'monthly') daily = rate / 30;
    return sum + daily * n * qty;
  }, 0);
  return Math.round(total * 100) / 100;
};

export const invoicesKeptOnReturn = (invoices = [], returnDate) =>
  (invoices || []).filter((inv) => {
    const status = String(inv.payment_status || '').toLowerCase();
    if (status === 'cancelled') return false;
    const due = String(inv.due_date || '').slice(0, 10);
    return !due || due <= returnDate;
  });
